import React, { Dispatch, FC, SetStateAction } from 'react';
import { useNavigate } from 'react-router';

import './MultiToggleSwitch.scss';

type MultiToggleSwitchProps = {
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  values: Array<{
    title: string;
    link: string;
  }>;
  size?: number;
};

const MultiToggleSwitch: FC<MultiToggleSwitchProps> = ({
  activeIndex,
  setActiveIndex,
  values,
  size = 1,
}) => {
  const navigate = useNavigate();

  return (
    <div className="multi-toggle-switch" style={{ transform: `scale(${size})` }}>
      {values.map((value, index) => (
        <button
          key={index}
          className={`multi-toggle-option ${activeIndex === index ? 'active' : ''}`}
          onClick={() => {
            setActiveIndex(index);
            navigate(`/${value.link}`);
          }}
        >
          {value.title}
        </button>
      ))}
      <div
        className="multi-toggle-slider"
        style={{
          width: `calc(100% / ${values.length})`,
          transform: `translateX(${activeIndex * 96}%)`,
        }}
      />
    </div>
  );
};

export default MultiToggleSwitch;
